/*eslint-disable*/
import React, { Component } from 'react'
import { connect } from 'react-redux'

//import Actions
import { getVehicleList } from '../../redux/actions/documentActions'
import { getJobCardType } from '../../redux/actions/inputApiActions'

//import Components
import VehicleList from '../../components/documentComponent/listVehicles'


class Document extends Component {
    
    componentDidMount() {
        this.getVehicleDocuments(1, 10)
    }
    
    getVehicleDocuments = (page,limit) => {
        let pagination_details = {page, limit}
        if (this.props.location.state !== null) {
            this.props.getVehicleList(this.props.location.state, pagination_details);
        } else {
            this.props.getVehicleList(null, pagination_details);
        }
    }
    
    
    render() {
        const { vehicleList, isLoading, paginationData} = this.props;
        return (
            <React.Fragment>
                <VehicleList {...this.props} vehicleList={vehicleList} isLoading={isLoading} getVehicleDocuments={this.getVehicleDocuments} paginationData={paginationData}/>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    vehicleList: state.getVehicleList.vehicleList.data,
    paginationData : state.getVehicleList.vehicleList.paginationData,
    isLoading: state.getVehicleList.isLoading,
    jobCardType: state.getJobCardType.jobCardType
})

export default connect(mapStatetoProps, {
    getVehicleList,
    getJobCardType
})(Document)